import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { Grid, Divider, Button, Card, Typography } from "@material-ui/core"
import MaterialDataGrid from "../../components/MaterialDataGrid"
import {
  renderOnSave,
  renderOnEdit,
  renderOnDiscard,
  renderSwitchHandler,
  renderItemChange,
  renderSelectionChange,
  renderSetDefaultValue,
  renderHeaderSelectionChange,
  renderUpdateTableFilterData,
  renderSingleSelectionChange,
} from "./renderProps"
import * as Adm from "@adm"
import { useHistory } from "react-router-dom"
import _ from "lodash"

function TableLocation(props) {
  const { t } = useTranslation()
  const {
    tableGlobalState,
    pageData,
    detailPageRoute,
    reDirectPath,
    queryParams = "",
    onRowClick,
    DontGoToUrl,
    deleteAnId,
    editVariable,
    isType = "singel",
    InTableRowEdit,
    onSaveHandler,
    additionalActions = () => {},
    ShowCheckBox = true,
    isOnRowClick = true,
    loading,
    hideCheckboxAll = false,
    isLookup = false,
    pageable = true,
    isGrid = false,
    isGridType = "1",
    isDirectClick = false,
    isAddOnPropsRowClick = false,
    deleteIcon = false,
    deleteDisabled = () => false,
    deleteTooltip = () => "Delete",
    onDeleteDisabled = () => {},
    deleteIconHolder = false,
  } = props || {}

  const { isWriteAllowed, isDeleteAllowed } = props || {}

  const {
    setGridState,
    gridState,
    items,
    setRowData,
    rowData,
  } = tableGlobalState
  const { columnData, data } = tableGlobalState
  let tttt = true
  let history = useHistory()
  return (
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Grid item>
        <MaterialDataGrid
          isGrid={isGrid}
          isGridType={isGridType}
          isDirectClick={isDirectClick}
          isInlineDeleteAllowed={isDeleteAllowed}
          isInlineEditAllowed={isWriteAllowed}
          additionalActions={additionalActions}
          itemChange={(event) => renderItemChange(event, tableGlobalState)}
          isLookup={isLookup}
          setDefaultValue={(event, props) =>
            renderSetDefaultValue(event, props, tableGlobalState)
          }
          headerSelectionChange={(event) =>
            renderHeaderSelectionChange(event, tableGlobalState)
          }
          selectionChange={(event) =>
            hideCheckboxAll
              ? renderSingleSelectionChange(event, tableGlobalState)
              : renderSelectionChange(event, tableGlobalState)
          }
          onDiscard={(props) =>
            renderOnDiscard(props, tableGlobalState, InTableRowEdit)
          }
          onEdit={(props) =>
            DontGoToUrl
              ? isAddOnPropsRowClick
                ? onRowClick(props)
                : onRowClick()
              : renderOnEdit(
                  props,
                  history,
                  tableGlobalState,
                  reDirectPath,
                  editVariable,
                  isType,
                  InTableRowEdit,
                  queryParams
                )
          }
          onDelete={(props) => {
            if (deleteAnId) deleteAnId(props)
          }}
          deleteIcon={deleteIcon}
          deleteDisabled={deleteDisabled}
          deleteTooltip={deleteTooltip}
          onDeleteDisabled={onDeleteDisabled}
          onSave={(props) =>
            InTableRowEdit
              ? onSaveHandler(props, tableGlobalState)
              : renderOnSave(props, tableGlobalState)
          }
          switchHandler={(event, props) =>
            renderSwitchHandler(event, props, tableGlobalState)
          }
          setGridState={setGridState}
          gridState={gridState}
          setRowData={setRowData}
          rowData={rowData}
          columnData={columnData}
          pathProps={detailPageRoute}
          pageData={pageData}
          actionMenu={true}
          actionDelete={true}
          number_of_items={items}
          onRowClick={props?.onRowClick}
          menutype={props.menutype}
          historyPopup={props?.historyPopup}
          ShowCheckBox={ShowCheckBox}
          isOnRowClick={isOnRowClick}
          hideCheckboxAll={hideCheckboxAll}
          pageable={pageable}
          deleteDisabled={deleteDisabled}
          deleteTooltip={deleteTooltip}
          deleteIcon={props?.deleteIcon}
          deleteIconHolder={props?.deleteIconHolder}
        />
      </Grid>
    </Grid>
  )
}
export { TableLocation }
